import { NgModule, Injectable } from '@angular/core';
import { AbstractSecurityStorage, AuthModule, StsConfigLoader } from 'angular-auth-oidc-client';
import { OidcConfigService, authFactory } from './oidc-config.service';

// localStorage inline para que code_verifier (PKCE) sobreviva el redirect OAuth
@Injectable()
class LocalStorageService extends AbstractSecurityStorage {
  read(key: string): any {
    return JSON.parse(localStorage.getItem(key) ?? 'null');
  }
  write(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }
  remove(key: string): void {
    localStorage.removeItem(key);
  }
  clear(): void {
    localStorage.clear();
  }
}

@NgModule({
  imports: [
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [OidcConfigService]
      }
    })
  ],
  providers: [
    // Usar localStorage para que el code_verifier (PKCE) sobreviva el redirect de Okta/Azure
    { provide: AbstractSecurityStorage, useClass: LocalStorageService }
  ],
  exports: [AuthModule]
})
export class AuthConfigModule { }
